import { render } from "./LayoutLoading.vue?vue&type=template&id=1a71b9e0"
import script from "./LayoutLoading.vue?vue&type=script&lang=js"
export * from "./LayoutLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__